import styled from "styled-components"

const Bound = styled.div`
    font-family: "UTM-Avo";
    ${props => props.specificStyles}
    ${props => props.stylesParent}
`

export { Bound };